/* eslint-disable @typescript-eslint/no-explicit-any */
import { Flex, List, Typography } from 'antd';
import { useLanguage } from 'hooks/Language/useLanguage';

const AccountDetails = ({ cardItem, userData }: any) => {
  const { Paragraph, Text } = Typography;
  const { translate } = useLanguage();

  return (
    <Flex vertical style={{ width: '100%' }}>
      <List
        dataSource={[
          <Flex justify="space-between" align="center" gap="large">
            <Flex align="flex-start" vertical>
              <Text type="secondary">{translate('Name')}</Text>
              <Text strong>
                {userData && userData[0]?.LastName}{' '}
                {userData && userData[0]?.FirstName}
              </Text>
            </Flex>
            <Paragraph
              copyable={{
                text: async () =>
                  new Promise((resolve) => {
                    setTimeout(() => {
                      resolve(
                        userData &&
                          `${userData && userData[0]?.LastName} ${userData && userData[0]?.FirstName}`,
                      );
                    }, 500);
                  }),
              }}
            />
          </Flex>,
          <Flex justify="flex-start" align="center" gap="large">
            <Flex
              align="flex-start"
              style={{ width: '100%' }}
              vertical
            >
              <Text type="secondary">
                {translate('Account number')}
              </Text>
              <Text strong>{cardItem?.AccountNumber}</Text>
            </Flex>
            <Paragraph
              copyable={{
                text: async () =>
                  new Promise((resolve) => {
                    setTimeout(() => {
                      resolve(cardItem?.AccountNumber);
                    }, 500);
                  }),
              }}
            />
          </Flex>,
          <Flex justify="space-between" align="center" gap="large">
            <Flex
              align="flex-start"
              style={{ width: '100%' }}
              vertical
            >
              <Text type="secondary">{translate('IBAN')}</Text>
              <Text strong>{cardItem?.IBAN}</Text>
            </Flex>

            <Paragraph
              copyable={{
                text: async () =>
                  new Promise((resolve) => {
                    setTimeout(() => {
                      resolve(cardItem?.IBAN);
                    }, 500);
                  }),
              }}
            />
          </Flex>,
        ]}
        renderItem={(item) => <List.Item>{item}</List.Item>}
      />
    </Flex>
  );
};

export default AccountDetails;
